import Chats from './Chats';
import * as ZApiInstances from './ZApiInstances';

export default {
  ZApiInstances,
  Chats,
};
